import { Map, View } from 'ol';
import { Osm, Nlsc } from './baseLayers';

/**
 * 地圖底圖方法
 * @param {Object} mapConfig 地圖config
 * {String} mapId map element id
 * {Object} options map option
 * {Array} baseLayers map base layers
 */
export default function MapFusion(mapConfig) {
    const baseLayers = [];
    if (mapConfig.baseLayers.length) {
        mapConfig.baseLayers.forEach((layer) => {
            switch (layer.type) {
                case 'osm':
                    baseLayers.push(new Osm(layer, layer.visible));
                    break;
                case 'nlsc':
                    baseLayers.push(
                        new Nlsc(
                            'EMAP',
                            layer.visible,
                            layer.type,
                            layer.isExport,
                        ),
                    );
                    break;
                case 'ortho':
                    baseLayers.push(
                        new Nlsc('PHOTO2', layer.visible, layer.type),
                    );
                    break;
                default:
                    break;
            }
        });
    } else {
        baseLayers.push(new Nlsc('EMAP', true));
    }

    const map = new Map({
        target: mapConfig.mapId,
        layers: baseLayers,
        view: new View(mapConfig.options),
        controls: [],
    });

    // 針對所有 Feature cursor 改 pointer
    const target = map.getTarget();
    const jTarget = typeof target === 'string'
        ? document.querySelector(`#${target}`)
        : document.querySelector(target);
    map.on('pointermove', (event) => {
        const mouseCoordInMapPixels = [
            event.originalEvent.offsetX,
            event.originalEvent.offsetY,
        ];

        const hit = map.forEachFeatureAtPixel(
            mouseCoordInMapPixels,
            () => true,
        );

        if (hit) {
            jTarget.style.cursor = 'pointer';
        } else {
            jTarget.style.cursor = '';
        }
    });

    // 地圖圖標綁定click事件
    map.on('singleclick', (evt) => {
        map.forEachFeatureAtPixel(evt.pixel, (f) => {
            const url = f.get('url');
            if (url) {
                const callback = f.get('callback');
                callback(url);
            }
        });
    });

    const fusion = {
        olmap: map,
        baseLayers,
    };

    return fusion;
}
